@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.modal {
  width: 400px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.title {
  margin: 0 32px 8px 0;
  @include t.text(20px, 30px, 600);
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fieldLabel {
  @include t.text(12px, 18px, 500);
  color: v.$palette-dirty-100;
}

.grid {
  display: grid;
  // grid-template-columns: 1fr 1fr;
  gap: 16px;

  // @media (max-width: 480px) {
  //   grid-template-columns: 1fr;
  // }
}

.placementTitle {
  margin: 0 0 8px;
  @include t.text(12px, 18px, 500);
  color: v.$palette-dirty-100;
}

.placementOptions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.placementItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  @include t.text(12px, 18px, 600);
  color: v.$palette-gray-900;

  span {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  input {
    accent-color: v.$palette-orange-2;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;

  button.save {
    color: v.$palette-white;
    background-color: v.$palette-orange-2;

    @media (pointer: fine) {
      &:hover {
        color: v.$palette-white;
        background-color: v.$palette-orange-3;
      }
    }
  }
}
